import { useEditorContext } from 'src/store/editor';
import { apiRemoveNodeFromJourney } from 'src/utils/journeyApi';

function getEditedJourney() {
  return useEditorContext.getState().journey;
}

const removeNodeFromCurrentJourney = (node_uuid: any, step_id: string) =>
  apiRemoveNodeFromJourney(node_uuid, step_id, getEditedJourney()?.uuid);

export { removeNodeFromCurrentJourney };
